// extracted by mini-css-extract-plugin
export default {"chip":"StatusChip_chip__EeO3+","chip--success":"StatusChip_chip--success__TyUoP","chip--warning":"StatusChip_chip--warning__MCTgS"};